import { render, staticRenderFns } from "./PetHealthTypeSickForm.vue?vue&type=template&id=36c48d95&scoped=true&"
import script from "./PetHealthTypeSickForm.vue?vue&type=script&lang=js&"
export * from "./PetHealthTypeSickForm.vue?vue&type=script&lang=js&"
import style0 from "./PetHealthTypeSickForm.vue?vue&type=style&index=0&id=36c48d95&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c48d95",
  null
  
)

export default component.exports